import { useCallback } from "react";

let sharedObserver: IntersectionObserver | null = null;

function getObserver(): IntersectionObserver | null {
  if (typeof window === "undefined" || !("IntersectionObserver" in window)) {
    return null;
  }
  if (!sharedObserver) {
    sharedObserver = new IntersectionObserver(
      (entries, obs) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            obs.unobserve(entry.target);
          }
        }
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" },
    );
  }
  return sharedObserver;
}

/**
 * Ref callback that fades an element in when it scrolls into view.
 * Falls back to always-visible if IntersectionObserver is unavailable.
 */
export function useReveal<T extends HTMLElement = HTMLElement>() {
  return useCallback((node: T | null) => {
    if (!node) return;
    const observer = getObserver();
    if (!observer) return; // no IO → element stays visible (no .reveal class)
    node.classList.add("reveal");
    observer.observe(node);
  }, []);
}
